import ManualBillingDocumentLedgerCode from '@/generated/controls/manualBillingDocument/ManualBillingDocumentLedgerCode.vue';
import { ManualBillingDocumentLedgerCodes } from '@/generated/classes/ManualBillingDocument';
import { defineComponent } from 'vue';
import Item from '@/framework/base/classes/Item';
import { FieldStatus } from '@/framework/base/components/FieldInfo';

export default defineComponent({
  components: {},
  extends: ManualBillingDocumentLedgerCode,

  data() {
    const items: Item[] = [
      { key: ManualBillingDocumentLedgerCodes.VTE, title: 'Vente' },
      { key: ManualBillingDocumentLedgerCodes.ABO, title: 'Abonnement' },
    ];
    return {
      initValue: 0,
      lastContextId: 0,
      status: new FieldStatus(false, false, 0),
      items,
    };
  },
});
